<template lang="pug">
		#easy-btn-container
			.easy-bg-svg
				.easy-any-text: | {{btnText}}
</template>

<script>
export default {
	name: 'easyBtn',
	props: [
		'btnText'
	]
}
</script>



// WEBPACK FOOTER //
// ../../easytitle24-2.x-common/components/easy-btn.vue